export default function DownloadSection() {
  return (
    <section id="download" className="w-full px-4 md:px-6 py-16 md:py-24 bg-foreground-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div
          className="w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://readdy.ai/api/search-image?query=Abstract%20dark%20textured%20background%20with%20subtle%20warm%20golden%20gradients%20and%20geometric%20patterns%2C%20elegant%20minimalist%20style%2C%20smooth%20gradients%2C%20professional%20design&width=1920&height=600&seq=download-bg-01&orientation=landscape)',
          }}
        ></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
          立即下载91影视看片app
        </h2>
        <p className="text-foreground-300 text-sm md:text-base mb-10 max-w-xl mx-auto">
          选择您的设备版本，免费下载最新安装包，开启高清观影之旅
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
          <a
            href="#"
            className="w-full sm:w-auto whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white font-semibold px-10 py-4 rounded-full text-base transition-all duration-300 hover:scale-105 cursor-pointer flex items-center justify-center gap-3 group"
          >
            <i className="ri-android-line text-xl group-hover:rotate-12 transition-transform duration-300"></i>
            <div className="text-left">
              <div className="text-xs opacity-80">安卓版下载</div>
              <div className="text-sm font-bold">APK安装包 V5.2.0</div>
            </div>
          </a>
          <a
            href="#"
            className="w-full sm:w-auto whitespace-nowrap bg-white/10 hover:bg-white/20 backdrop-blur-md text-white font-semibold px-10 py-4 rounded-full text-base transition-all duration-300 hover:scale-105 cursor-pointer border border-white/20 flex items-center justify-center gap-3 group"
          >
            <i className="ri-apple-line text-xl group-hover:rotate-12 transition-transform duration-300"></i>
            <div className="text-left">
              <div className="text-xs opacity-80">苹果版下载</div>
              <div className="text-sm font-bold">iOS安装包 V5.2.0</div>
            </div>
          </a>
        </div>

        <div className="mt-8 flex items-center justify-center gap-6 text-white/50 text-xs">
          <span className="flex items-center gap-1">
            <i className="ri-checkbox-circle-line text-green-400"></i>
            支持Android 7.0+
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-checkbox-circle-line text-green-400"></i>
            支持iOS 13.0+
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-checkbox-circle-line text-green-400"></i>
            安全无毒认证
          </span>
        </div>
      </div>
    </section>
  );
}